import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import SubscriberPortal from "./SubscriberPortal";

createRoot(document.getElementById("tmt-event-subscriber-portal")).render(
  <StrictMode>
    <SubscriberPortal />
  </StrictMode>
);
